import {
  Form,
  FormField,
  FormFieldConditions,
  FormSection,
  FormType,
} from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { ChoferModel } from 'src/app/models/ventas/tablas-maestras.model';
import { environment } from 'src/environments/environment';

export class ChoferFormDefinition {
  public readonly appName = environment.appName;
  public lastFieldChanged = '';
  public requestType: FormType = FormType.CREATION;
  public model: Partial<ChoferModel> = {};
  public formFields: Form<ChoferModel>;

  constructor(type: FormType, model: Partial<ChoferModel>) {
    this.requestType = type;
    this.model = model;
    this.formFields = {
      name: 'chofer',
      header: 'Datos del chofer',
      type: +type as FormType,
      sections: this.getSections(),
      table: null,
      uploadButton: {
        isEnabled: false,
        label: '',
      },
      signed: false,
    };
  }

  public formChanges(tag: string): void {
    this.lastFieldChanged = tag;
  }

  private getSections(): FormSection<ChoferModel>[] {
    return [
      {
        name: '',
        fields: this.getFields(),
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private getFields(): FormField<ChoferModel>[] {
    return [
      {
        name: 'nombre',
        vinculatedFields: undefined,
        label: 'Nombre',
        input: {
          type: InputType.TEXT,
          isEditable: true,
        },
        width: 4,
        conditions: this.conditions({ isRequired: true }),
        order: 1,
      },
    ];
  }

  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }
}
